import {create} from "zustand";

export const useNotSizeStore = create((set) => ({
    notSizeState: {
        open: false,
        productId: null,
        productData: []
    },

    openModalNotSize: (data) => set({
        notSizeState: {
            ...data,
            open: true,
        }
    }),

    closeModalNotSize: () => set({
        notSizeState: {
            open: false,
            productId: null,
            productData: [],
        }
    }),
}));
